module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/hero-66b7abae47603e5384edad6360f390b8.jpg";